import React from "react";
import styled from "styled-components";
import {
  Flex,
  Box,
  Container,
  Row,
  Card,
  Banner,
  Heading,
  Subhead,
  Text,
  Divider,
  Embed,
  BackgroundImage,
} from "rebass";
import { plural } from "../utils/helpers";
import Icon from "../components/Icon";
import Link from "gatsby-link";
import logOutboundLink from "../utils/log-outbound-link";
import Img from "gatsby-image";
import moment from "moment";

const HeartButton = styled(Icon)`
  :hover {
    cursor: pointer;
    color: #c1292e;
  }
`;

const NavIcon = styled(Icon)`
  position: relative;
  float: right;
  z-index: 1;
  right: 35px;
  margin-right: -35px;
  width: 25px;
  height: 25px;
  background: #c3bbe78a;
`;

const PostHeading = styled(Heading)`
  text-align: center;
`;

const ProductCard = styled(Card)`
  height: 100px;
  width: 150px;
  margin-right: 2vw;
`;

const BannerHome = styled(Banner)`
  min-height: 200px;
  height: 400px;
  max-height: 400px;
  text-decoration: none;
`;

const BannerWrap = styled.div`
  background-color: #0066ff;
`;

class PostBanner extends React.Component {
  renderURL() {
    if (this.props.url !== "http://nothingyet.com") {
      return (
        <a href={this.props.url} target="_blank">
          <ProductCard m={2}>
            <NavIcon color="white" name="arrow-up-right" />
            <BackgroundImage>
              <Img sizes={this.props.img.sizes} />
            </BackgroundImage>
          </ProductCard>
        </a>
      );
    } else {
      return (
        <ProductCard m={2}>
          <BackgroundImage>
            <Img sizes={this.props.img.sizes} />
          </BackgroundImage>
        </ProductCard>
      );
    }
  }

  renderTimeField() {
    // find countdown difference in days from launch for products
    if (this.props.type == "product") {
      const threeMonths = moment(this.props.date).add(30, "days");
      const today = moment();
      const launchDate = moment(this.props.date).format("x");

      const countdown = threeMonths.diff(today, "days");

      //set val to launch date + 3 months and check if today is greater

      if (threeMonths > today && this.props.status !== "Building") {
        return (
          <div>
            <Subhead m={1} fontSize={3} textAlign="center" color="gray1">
              {" "}
              ⏱ Time left
            </Subhead>
            <Text textAlign="center" color="white">
              {countdown} days
            </Text>
          </div>
        );
      } else if (this.props.status == "Building") {
        return (
          <div>
            <Subhead m={1} fontSize={3} textAlign="center" color="gray1">
              {" "}
              ⏱ Time left
            </Subhead>
            <Text textAlign="center" color="white">
              N/A
            </Text>
          </div>
        );
      } else {
        return (
          <div>
            <Subhead m={1} fontSize={3} textAlign="center" color="gray1">
              {" "}
              ⏱ Launched on
            </Subhead>
            <Text textAlign="center" color="white">
              {" "}
              {moment(this.props.date).format("MMM D, YYYY")}
            </Text>
          </div>
        );
      }
    } else if (this.props.type == "article") {
      const oneMonths = moment(this.props.date).add(30, "days");
      const today = moment();
      const launchDate = moment(this.props.date).format("x");

      const countdown = oneMonths.diff(today, "days");

      //set val to launch date + 3 months and check if today is greater

      if (oneMonths > today) {
        return (
          <div>
            <Subhead m={1} fontSize={3} textAlign="center" color="gray1">
              {" "}
              ⏱ Time left
            </Subhead>
            <Text textAlign="center" color="white">
              {countdown} days
            </Text>
          </div>
        );
      } else {
        return (
          <div>
            <Subhead m={1} fontSize={3} textAlign="center" color="gray1">
              {" "}
              ⏱ Launched on
            </Subhead>
            <Text textAlign="center" color="white">
              {" "}
              {moment(this.props.date).format("MMM D, YYYY")}
            </Text>
          </div>
        );
      }
    } else if (this.props.type == "video") {
      const oneMonths = moment(this.props.date).add(30, "days");
      const today = moment();
      const launchDate = moment(this.props.date).format("x");

      const countdown = oneMonths.diff(today, "days");

      //set val to launch date + 3 months and check if today is greater

      if (oneMonths > today) {
        return (
          <div>
            <Subhead m={1} fontSize={3} textAlign="center" color="gray1">
              {" "}
              ⏱ Time left
            </Subhead>
            <Text textAlign="center" color="white">
              {countdown} days
            </Text>
          </div>
        );
      } else {
        return (
          <div>
            <Subhead m={1} fontSize={3} textAlign="center" color="gray1">
              {" "}
              ⏱ Launched on
            </Subhead>
            <Text textAlign="center" color="white">
              {" "}
              {moment(this.props.date).format("MMM D, YYYY")}
            </Text>
          </div>
        );
      }
    }
  }

  render() {
    const embedURL =
      "https://www.youtube.com/embed/" + this.props.youtubeid + "?showinfo=0";

    // PRODUCT BANNER

    if (this.props.type == "product") {
      return (
        <div>
          <BannerHome bg="#0066FF">
            <Flex flexWrap="wrap" justifyContent="center">
              <Box>{this.renderURL()}</Box>

              <Box my="auto">
                <PostHeading is="h1" fontSize={[4, 4, 6]} color="white">
                  {this.props.title}
                </PostHeading>
              </Box>
            </Flex>
          </BannerHome>
          <BannerWrap>
            <div
              style={{
                maxWidth: `850px`,
                marginRight: `auto`,
                marginLeft: `auto`,
              }}
            >
              <Flex bg="base" flexWrap="wrap" px={3} py={3}>
                <Box width={[1, 1 / 4]} p={1}>
                  <Subhead m={1} fontSize={3} textAlign="center" color="gray1">
                    {" "}
                    💻 Status
                  </Subhead>
                  <Text textAlign="center" color="white">
                    {this.props.status}
                  </Text>
                </Box>
                <Box width={[1, 1 / 4]} p={1}>
                  {this.renderTimeField()}
                </Box>
                <Box width={[1, 1 / 4]} p={1}>
                  <Subhead m={1} fontSize={3} textAlign="center" color="gray1">
                    {" "}
                    💵 Revenue
                  </Subhead>
                  <Text textAlign="center" color="white">
                    {this.props.revenue}
                  </Text>
                </Box>
                <Box width={[1, 1 / 4]} p={1}>
                  <a
                    href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
                      `${this.props.title} - http://launchingmyself.com/${this.props.slug}`
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => logOutboundLink("tweet")}
                  >
                    <Subhead
                      m={1}
                      fontSize={3}
                      textAlign="center"
                      color="gray1"
                    >
                      {" "}
                      🐦 Shares
                    </Subhead>
                    <Text textAlign="center" color="white">
                      {this.props.hearts}
                    </Text>
                  </a>
                </Box>
              </Flex>
            </div>
          </BannerWrap>
        </div>
      );
    }

    // ARTICLE BANNER
    else if (this.props.type == "article") {
      return (
        <div>
          <BannerHome bg="#C1292E">
            <Container py={0} my={0} px="5%">
              <PostHeading mx="auto" is="h1" fontSize={[3, 4, 6]} color="white">
                {this.props.title}
              </PostHeading>
            </Container>
          </BannerHome>
          <BannerWrap style={{ backgroundColor: `#C1292E` }}>
            <div
              style={{
                maxWidth: `850px`,
                marginRight: `auto`,
                marginLeft: `auto`,
              }}
            >
              <Flex bg="#C1292E" flexWrap="wrap" px={3} py={3}>
                <Box width={[1, 1 / 4]} p={1}>
                  <Subhead m={1} fontSize={3} textAlign="center" color="gray1">
                    {" "}
                    💻 Status
                  </Subhead>
                  <Text textAlign="center" color="white">
                    {this.props.status}
                  </Text>
                </Box>
                <Box width={[1, 1 / 4]} p={1}>
                  {this.renderTimeField()}
                </Box>
                <Box width={[1, 1 / 4]} p={1}>
                  <Subhead m={1} fontSize={3} textAlign="center" color="gray1">
                    {" "}
                    📚 Read time
                  </Subhead>
                  <Text textAlign="center" color="white">
                    {plural(this.props.readTime, "min", "s")}
                  </Text>
                </Box>
                <Box width={[1, 1 / 4]} p={1}>
                  <a
                    href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
                      `${this.props.title} - http://launchingmyself.com/${this.props.slug}`
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => logOutboundLink("tweet")}
                  >
                    <Subhead
                      m={1}
                      fontSize={3}
                      textAlign="center"
                      color="gray1"
                    >
                      {" "}
                      🐦 Shares
                    </Subhead>
                    <Text textAlign="center" color="white">
                      {this.props.hearts}
                    </Text>
                  </a>
                </Box>
              </Flex>
            </div>
          </BannerWrap>
        </div>
      );
    }

    // VIDEO BANNER
    else if (this.props.type == "video") {
      return (
        <div style={{ backgroundColor: "#000000" }}>
          <Container py={0} my={0}>
            <Embed bg="#000000">
              <iframe
                width="560"
                height="315"
                src={embedURL}
                frameBorder="0"
                allowFullScreen
              />
            </Embed>
            <Flex flexWrap="wrap" px={3} py={5}>
              <PostHeading mx="auto" is="h1" fontSize={[3, 3, 5]} color="white">
                {this.props.title}
              </PostHeading>
            </Flex>
          </Container>
          <BannerWrap style={{ backgroundColor: `#000000` }}>
            <div
              style={{
                maxWidth: `850px`,
                marginRight: `auto`,
                marginLeft: `auto`,
              }}
            >
              <Flex bg="#000000" flexWrap="wrap" px={3} py={3}>
                <Box width={[1, 1 / 4]} p={1}>
                  <Subhead m={1} fontSize={3} textAlign="center" color="gray1">
                    {" "}
                    💻 Status
                  </Subhead>
                  <Text textAlign="center" color="white">
                    {this.props.status}
                  </Text>
                </Box>
                <Box width={[1, 1 / 4]} p={1}>
                  {this.renderTimeField()}
                </Box>
                <Box width={[1, 1 / 4]} p={1}>
                  <Subhead m={1} fontSize={3} textAlign="center" color="gray1">
                    {" "}
                    📹 Views
                  </Subhead>
                  <Text textAlign="center" color="white">
                    {this.props.views}
                  </Text>
                </Box>
                <Box width={[1, 1 / 4]} p={1}>
                  <a
                    href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
                      `${this.props.title} - http://launchingmyself.com/${this.props.slug}`
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => logOutboundLink("tweet")}
                  >
                    <Subhead
                      m={1}
                      fontSize={3}
                      textAlign="center"
                      color="gray1"
                    >
                      {" "}
                      🐦 Shares
                    </Subhead>
                    <Text textAlign="center" color="white">
                      {this.props.hearts}
                    </Text>
                  </a>
                </Box>
              </Flex>
            </div>
          </BannerWrap>
        </div>
      );
    }
  }
}

export default PostBanner;
